module.exports = __webpack_public_path__ + "static/media/settings-work-tool.8b988612.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings-work-tool.svg
// module id = 947
// module chunks = 5